import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1d9ccd51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link active",
      id: "home-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#home-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "home-tab-pane",
      "aria-selected": "true"
    }, "Information générale")
  ]),
  /*#__PURE__*/_createElementVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "nav-link",
      id: "profile-tab",
      "data-bs-toggle": "tab",
      "data-bs-target": "#profile-tab-pane",
      type: "button",
      role: "tab",
      "aria-controls": "profile-tab-pane",
      "aria-selected": "false"
    }, "Méta data")
  ])
], -1))
const _hoisted_4 = {
  class: "tab-content",
  id: "myTabContent "
}
const _hoisted_5 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-3 mt-3" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both !important"} }, null, -1))
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Titre "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Alias "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Sous titre "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_20 = { class: "col-md-12" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Contenu de l'article "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_23 = { class: "mb-0" }
const _hoisted_24 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_25 = { class: "product-upload" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Autres fichiers", -1))
const _hoisted_27 = { class: "dz-message needsclick" }
const _hoisted_28 = { class: "col-md-6 mt-3" }
const _hoisted_29 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Image principale ", -1))
const _hoisted_31 = { class: "col-md-6 mt-3" }
const _hoisted_32 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Icône de l'article ", -1))
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Catégorie "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10 d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" Tags "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "btn btn-primary py-1 px-2 fs-12",
      "data-bs-toggle": "modal",
      "data-bs-target": "#AddNewTagModal"
    }, " Ajouter + ")
  ])
], -1))
const _hoisted_40 = { class: "col-md-4" }
const _hoisted_41 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de publication ", -1))
const _hoisted_43 = { class: "col-md-4" }
const _hoisted_44 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Source de l'article ", -1))
const _hoisted_46 = { class: "col-md-4" }
const _hoisted_47 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Niveau ", -1))
const _hoisted_49 = {
  class: "tab-pane fade p-10",
  id: "profile-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Meta title ", -1))
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Meta Keyword ", -1))
const _hoisted_57 = { class: "col-md-12" }
const _hoisted_58 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Meta description ", -1))
const _hoisted_60 = { class: "mb-0" }
const _hoisted_61 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-md-12" }
const _hoisted_64 = { class: "d-flex align-items-center" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
  type: "submit"
}, " Ajouter un article ", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_DropZone = _resolveComponent("DropZone")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AddNewTagModal = _resolveComponent("AddNewTagModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Form, {
          ref: "articleForm",
          onSubmit: _ctx.addArticle,
          "validation-schema": _ctx.articleSchema
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("label", _hoisted_9, [
                        _createVNode(_component_Field, {
                          name: "alaune",
                          type: "checkbox",
                          modelValue: _ctx.defaultAlaune,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.defaultAlaune) = $event)),
                          value: true,
                          "unchecked-value": false,
                          class: "form-check-input me-2"
                        }, null, 8, ["modelValue"]),
                        _createTextVNode(" Est à la Une ? ")
                      ]),
                      _createVNode(_component_ErrorMessage, {
                        name: "alaune",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_Field, {
                        name: "titre",
                        type: "text",
                        modelValue: _ctx.title,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.title) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer le titre"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "titre",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_Field, {
                        name: "alias",
                        type: "text",
                        readonly: "true",
                        modelValue: _ctx.alias,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.alias) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer l'alias"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "alias",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_Field, {
                        name: "sousTitre",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer le sous titre"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "sousTitre",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_QuillEditor, {
                          ref: "contenuEditor",
                          theme: "snow",
                          placeholder: "Écrivez le contenu",
                          toolbar: "full",
                          name: "contenu"
                        }, null, 512)
                      ]),
                      (_ctx.show === '1')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_24, "Ce champ est obligatoire"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_DropZone, {
                        name: "fichiers[]",
                        uploadOnDrop: true,
                        multipleUpload: true,
                        parallelUpload: 3,
                        maxFilesize: 100,
                        filesizeBase: 1024,
                        maxFiles: 100,
                        acceptedFiles: [
                      'image/jpeg',
                      'image/png',
                      'image/jpg',
                      'video/mp4',
                      'video/webm',
                      'video/ogg',
                      'video/quicktime'  // pour les .mov
                    ],
                        onAddedFile: _ctx.onFileAdd
                      }, null, 8, ["onAddedFile"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createVNode(_component_Field, {
                        name: "urlImage",
                        type: "file",
                        accept: "image/jpeg, image/png application/pdf",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Choisir une image"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "urlImage",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createVNode(_component_Field, {
                        name: "icone",
                        type: "file",
                        accept: "image/jpeg, image/png ",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Choisir une icône"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "icone",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createVNode(_component_Field, { name: "categorieArticle" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: _ctx.categorieArticlesOptions,
                            searchable: true,
                            "track-by": "label",
                            label: "label",
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, { placeholder: "Sélectionner la catégorie" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "categorieArticle",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createVNode(_component_Field, { name: "tags" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: _ctx.tagsOptions,
                            searchable: true,
                            multiple: "true",
                            mode: "tags",
                            "track-by": "label",
                            label: "label",
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, { placeholder: "Sélectionner le tag" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "tags",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createVNode(_component_Field, {
                        name: "datePublication",
                        type: "date",
                        value: _ctx.getCurrentDate(),
                        class: "form-control shadow-none fs-md-15 text-black"
                      }, null, 8, ["value"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "datePublication",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createVNode(_component_Field, {
                        name: "source",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "source",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createVNode(_component_Field, {
                        name: "niveau",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "niveau",
                        class: "text-danger"
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createVNode(_component_Field, {
                        name: "metaTitle",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer le meta title"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "metaTitle",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createVNode(_component_Field, {
                        name: "metaKeyword",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer le meta keyword"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "metaKeyword",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("div", _hoisted_60, [
                        _createVNode(_component_QuillEditor, {
                          ref: "metaDescriptionEditor",
                          theme: "snow",
                          placeholder: "Ecrire la meta description",
                          toolbar: "full",
                          name: "metaDescription"
                        }, null, 512)
                      ]),
                      (_ctx.show === '1')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_61, "Ce champ est obligatoire"))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createVNode(_component_router_link, {
                    to: "/liste-articles",
                    class: "btn btn-danger transition border-0 lh-1 fw-medium"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_66,
                      _hoisted_67,
                      _createTextVNode("Annuler")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ]),
    _createVNode(_component_AddNewTagModal, { onClose: _ctx.rechargertag }, null, 8, ["onClose"])
  ], 64))
}